import StripeService, {type StripePayment} from '@/core/stripe';
import type {Country} from '@/config/country/type';
import {ref} from 'vue';
import {getCancelUrl, getSuccessUrl} from '@/core/util/url-utils';
import api from '@/core/api';
import { useI18n } from 'vue-i18n'
import useLoggable from '@/composables/loggable';

const useStripe = (country: Country) => {
    const { t } = useI18n()
    const stripePayment = ref<false| StripePayment>(false);
    const loading = ref(false);
    const error = ref<null|string>(null);
    const { info } = useLoggable();

    const loadStripe = async () => {
        if (stripePayment.value) {
            return
        }
        stripePayment.value = await StripeService.getPaymentService(country);
        if (stripePayment.value === false) {
            error.value = t('message.error.default');
            return false;
        }
    }

    const payWithStripe = async (paymentRef: string) => {

        if (loading.value) {
          return;
        }
        loading.value = true;

        info('User try to pay', {});

        if (!stripePayment.value) {
            throw new Error('Payment not initialized');
        }
        error.value = null;

        // When the customer clicks on the button, get a NEW stripe session id each time
        // 1. Checkout Sessions expire after payment succeed.
        // 2. Checkout Sessions expire 24 hours after creation.
        const stripeSession = await api.payment.checkoutTransactionId('card', country.displayCode.toLowerCase(), paymentRef, {
            successUrl: getSuccessUrl(window.location.host, window.location.protocol, country.displayCode) + '?stripe_id={CHECKOUT_SESSION_ID}',
            cancelUrl: getCancelUrl(window.location.host, window.location.protocol, country.displayCode)
        });

        if(!stripeSession.id) {
            loading.value = false;
            error.value = t('message.error.default');
            return;
        }

        // setPaymentSessionId(stripeSession.id);
        // setPaymentType('card');

        // redirect to stripe Checkout page.
        loading.value = false;
        info('Redirect to stripe Checkout page.', {});
        await stripePayment.value.redirectToCheckout(stripeSession.id);

        return;
    }

    loadStripe();

    return {
        stripePayment,
        loading,
        error,
        payWithStripe
    }
}

export default useStripe;